<template>
    <article>
        <AppBreadcrumbs
            :base-url="runtimeConfig.public.BASE_URL"
            :parents="[
                {
                    name: config.brand_name,
                    full_slug: '',
                },
                ...parentPages,
            ]"
            :current="{
                name: article.name,
                full_slug: article.full_slug,
            }"
        />
        <main class="page__content">
            <StoryblokComponent
                v-for="(blok, index) in article.content.body"
                :key="blok._uid"
                :story="article"
                :blok="blok"
                :priority="index === 0"
            />
        </main>
    </article>
</template>

<script setup>
import seoTitle from '~/helpers/seoTitle'

const { data } = defineProps({
    data: {
        type: Object,
        required: true,
    },
})

const config = useState('config')

const route = useRoute()
const { slug } = route.params

const runtimeConfig = useRuntimeConfig()

const { article } = data

const parentPages = computed(() => {
    if (Array.isArray(slug) && slug.length > 1) {
        return slug.filter(item => item !== '').slice(0, -1).map((item, index) => {
            return {
                name: (item.charAt(0).toUpperCase() + item.slice(1)).replace('-', ' '),
                full_slug: `${slug.slice(0, index + 1).join('/')}`,
            }
        })
    }

    return []
})

// Only ever opt OUT: useRobotsRule writes the rule unconditionally, so calling it with a
// truthy value would re-enable indexing on hosts the site-config plugin marks non-indexable.
// `noindex, follow` and not `useRobotsRule(false)`: `false` resolves to the module's
// `robotsDisabledValue` (`noindex, nofollow`), and these are folder hubs whose children are
// indexable — the nofollow cut the only crawl path to them.
if (article.content.index === false) {
    useRobotsRule('noindex, follow')
}

useHead({
    title: seoTitle(article),
    meta: [
        {
            hid: 'description',
            name: 'description',
            content: article.content.meta_description,
        },
    ],
})
</script>

<style lang="scss" scoped>
main:has(> div > .article__text:first-child) {
    padding: 20px 0;

    // A negative margin cannot cancel padding, so drop it when a band closes the page.
    &:has(> .component--full-width:last-child) {
        padding-bottom: 0;
    }
}
</style>
